import React, { useEffect, useRef, useState } from 'react';
import { getCountries, getCountryCallingCode, parsePhoneNumberFromString, isPossiblePhoneNumber } from 'libphonenumber-js/min';
import { commonCountries, useCareerLanguage } from './CareerLanguage';
import CareerField from './CareerField';

const countries = getCountries();
export const phonePossible = value => !!value && isPossiblePhoneNumber(value);
export function splitPhone(value, fallback = 'TR') {
  const country = countries.includes(fallback) ? fallback : 'TR';
  const parsed = value && parsePhoneNumberFromString(value, { defaultCountry:country, extract:false });
  return parsed ? { country:parsed.country || country, number:String(parsed.nationalNumber) } : { country, number:value || '' };
}
export function joinPhone(number, country) {
  if (!number.trim()) return '';
  const text = number.trim().replace(/^00/, '+');
  const parsed = parsePhoneNumberFromString(text, {defaultCountry:country, extract:false});
  return parsed?.number || (text.startsWith('+') ? text : '+'+getCountryCallingCode(country)+text.replace(/[\s().-]/g,''));
}

export default function CareerPhone({value, onChange, defaultCountry = 'TR',disabled=false}) {
  const {t,lang} = useCareerLanguage();
  const [draft,setDraft] = useState(()=>splitPhone(value,defaultCountry));
  const emitted = useRef(value), input = useRef(null);
  useEffect(()=>{
    if (value !== emitted.current) {setDraft(splitPhone(value,defaultCountry));emitted.current=value;}
  },[value,defaultCountry]);
  useEffect(()=>{
    input.current?.setCustomValidity(phonePossible(value) ? '' : t('phoneInvalid'));
  },[value,t]);
  const names = new Intl.DisplayNames([lang],{type:'region'});
  const others = countries.filter(code=>!commonCountries.includes(code)).sort((a,b)=>names.of(a).localeCompare(names.of(b),lang));
  const update = next => {
    const combined = joinPhone(next.number,next.country);
    // Pasting an international number automatically selects its calling code.
    if (/^(\+|00)/.test(next.number.trim())) next=splitPhone(combined,next.country);
    setDraft(next);emitted.current=combined;onChange(combined);
  };
  const option = code => <option key={code} value={code}>{names.of(code)} (+{getCountryCallingCode(code)})</option>;
  return <div className="cw-phone"><label>{t('phoneCountry')}<select disabled={disabled} value={draft.country} onChange={e=>update({...draft,country:e.target.value})} autoComplete="tel-country-code">{commonCountries.map(option)}<optgroup label={t('otherCountries')}>{others.map(option)}</optgroup></select></label><CareerField name="telefon">{t('phone')}<input ref={input} disabled={disabled} type="tel" required autoComplete="tel-national" inputMode="tel" maxLength={30} placeholder={draft.country==='TR'?'555 123 45 67':''} value={draft.number} onChange={e=>update({...draft,number:e.target.value})} /></CareerField></div>;
}
